/** Sales-summary chart metric (mirrors backend `dashboard_metric_enum`). */
export type ChartMetric = "sales" | "bill_count" | "remaining_waste";

export const METRIC_OPTIONS: { value: ChartMetric; label: string }[] = [
  { value: "sales", label: "ยอดขาย" },
  { value: "bill_count", label: "จำนวนบิล" },
  { value: "remaining_waste", label: "ของเหลือ/เสีย" },
];
